import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import BookingHotel from "../types/bookingHotel";

type Output = BookingHotel;

export default function useBookingHotelGet(
    bookingHotelId: string,
    options?: CacheQueryOpts<Output>
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    const cleanId = bookingHotelId.replace(/^\//, '');
    return useCacheQuery<Output>(
        ["booking", "hotels", cleanId],
        () => {
            return client.get<Output>(cleanId);
        },
        options
    );
}
